module.exports = "<div class=\"panel panel-default\">\n    <div class=\"panel-heading\">\n      <h4 class=\"panel-title\">\n        <a class=\"accordion-toggle\"\n          v-on=\"click:toggleIsOpen(this)\">\n           {{ header }}\n        </a>\n      </h4>\n    </div>\n    <div class=\"panel-collapse\"\n      v-el=\"panel\"\n      v-show=\"isOpen\"\n      v-transition=\"collapse\"\n    >\n      <div class=\"panel-body\">\n        <content></content>\n      </div>\n    </div>\n  </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Panel.vue
 ** module id = 120
 ** module chunks = 0
 **/